import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    backgroundColor: '#2c3e50',
    height: '40px',
    color:'white',
    fontSize:'12px',
    fontWeight:'bold',
    '&  a': {
      color:'white !important',
      fontSize:'12px',
      fontWeight: 600,
      textDecoration:'none',
    },
    [theme.breakpoints.down('750')]: {
      flexDirection: 'column',
      height: 'unset'
    },
  },
  social: {
    display: 'flex',
    justifyContent: 'space-around',
    '& > p': {
      marginRight:'20px',
    }
  },

}))